<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 md6 xl4>
        <v-card light>
          <v-toolbar dark>
            <v-toolbar-title>重設密碼</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <h2 class="text-center my-6">請查看電子信箱，完成重設密碼程序。</h2>
            <div class="text-right">
              <v-btn to="/login" text color="primary" style="text-decoration: underline">回到登入頁</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>



<script>
import { mapState, mapActions } from "vuex";

export default {
  components: {},

  mixins: [],

  props: [],
  data() {
    return {};
  },

  computed: {},
  watch: {},
  methods: {
    ...mapActions("system", ["set_snackbar"])
  },

  mounted() {}
};
</script>

<style lang="scss" scoped>
</style>
